import { ReactNode, PropsWithChildren, JSX, Suspense } from 'react';
import { ErrorBoundary } from '@bg-components/ErrorBoundary';
import { GeneralError } from '@bg-components/ErrorBoundary/GeneralError';

interface IProps {
    loader?: ReactNode;
}

export const LazyComponent = ({
    loader = null,
    ...props
}: PropsWithChildren<IProps>): JSX.Element => (
    <ErrorBoundary ErrorComponent={GeneralError}>
        <Suspense fallback={loader}>{props.children}</Suspense>
    </ErrorBoundary>
);
